import { createFileRoute } from "@tanstack/react-router"
import { Section } from "design-system/molecules/Section"
import { useAuthEmployeeQuery } from "modules/auth/hooks/useAuthEmployeeQuery"
import { AllCardsUnderCompany, CompanyCards, OrganizationCards } from "modules/settings/components"
import { useTranslation } from "react-i18next"

function SettingsIndex() {
  const { t } = useTranslation()
  const { data: employee } = useAuthEmployeeQuery()
  const isSingleCompany = (employee?.organization?.companies?.length ?? 0) === 1
  const canViewOrganization = Boolean(employee?.isOwner || employee?.isManager)

  return (
    <div className="flex flex-col gap-8">
      {isSingleCompany ? (
        <AllCardsUnderCompany />
      ) : (
        <>
          <Section title={t("settings.sections.company")}>
            <CompanyCards />
          </Section>
          {canViewOrganization && (
            <Section title={t("settings.sections.organization")}>
              <OrganizationCards />
            </Section>
          )}
        </>
      )}
    </div>
  )
}

export const Route = createFileRoute("/_base/_auth/settings/")({
  component: SettingsIndex,
})
